export enum WidgetType {
    Chart,
    Box,
    Metrics,
    Grid
}
